var _path, _path2;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgHeroiconsEye1(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 80,
    height: 80,
    viewBox: "0 0 80 80",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6.78679 41.0733C6.55675 40.382 6.55675 39.6347 6.78679 38.9433C11.4101 25.0333 24.5335 15 40.0001 15C55.4601 15 68.5768 25.0233 73.2101 38.9267C73.4434 39.6167 73.4434 40.3633 73.2101 41.0567C68.5901 54.9667 55.4668 65 40.0001 65C24.5401 65 11.4235 54.9767 6.79012 41.0733H6.78679Z",
    stroke: "#A95959",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M50 40C50 42.6522 48.9464 45.1957 47.0711 47.0711C45.1957 48.9464 42.6522 50 40 50C37.3478 50 34.8043 48.9464 32.9289 47.0711C31.0536 45.1957 30 42.6522 30 40C30 37.3478 31.0536 34.8043 32.9289 32.9289C34.8043 31.0536 37.3478 30 40 30C42.6522 30 45.1957 31.0536 47.0711 32.9289C48.9464 34.8043 50 37.3478 50 40V40Z",
    stroke: "#A95959",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgHeroiconsEye1);
export default __webpack_public_path__ + "static/media/heroicons_eye1.68534b1a1cffba69ad4a3b650ae45f6b.svg";
export { ForwardRef as ReactComponent };